/**
 * Returns a list with auxiliaries for the French passive voice assessment.
 * @returns {Array} The list with auxiliaries.
 */
export default function() {
	return [
		"être",
		"d'être",
		"suis",
		"es",
		"est",
		"sommes",
		"êtes",
		"sont",
		"n'est",
		"n'es",
		"n'êtes",
		"été",
		"j'étais",
		"étais",
		"était",
		"étions",
		"étiez",
		"étaient",
		"c'était",
		"n'étais",
		"n'était",
		"n'étions",
		"n'étiez",
		"n'étaient",
		"serai",
		"seras",
		"sera",
		"serons",
		"serez",
		"seront",
		"sois",
		"soit",
		"soyons",
		"soyez",
		"soient",
		"fusse",
		"fusses",
		"fût",
		"fussions",
		"fussiez",
		"fussent",
		"serais",
		"serait",
		"serions",
		"seriez",
		"seraient",
		"fus",
		"fut",
		"fûmes",
		"fûtes",
		"furent",
		"suis-je",
		"es-tu",
		"est-il",
		"est-elle",
		"est-on",
		"sommes-nous",
		"êtes-vous",
		"sont-ils",
		"sont-elles",
		"est-ce",
		"étais-je",
		"étais-tu",
		"était-il",
		"était-elle",
		"était-on",
		"était-ce",
		"étions-nous",
		"étiez-vous",
		"étaient-ils",
		"étaient-elles",
		"serai-je",
		"seras-tu",
		"sera-t-il",
		"sera-t-elle",
		"sera-t-on",
		"sera-ce",
		"serons-nous",
		"serez-vous",
		"seront-ils",
		"seront-elles",
		"serais-je",
		"serais-tu",
		"serait-il",
		"serait-elle",
		"serait-on",
		"serait-ce",
		"serions-nous",
		"seriez-vous",
		"seraient-ils",
		"seraient-elles",
		"fus-je",
		"fus-tu",
		"fut-il",
		"fut-elle",
		"fut-on",
		"fut-ce",
		"fûmes-nous",
		"fûtes-vous",
		"furent-ils",
		"furent-elles",
	];
}
